import React from "react";
import "./AboutUsSingle.css";

const AboutUsSingle = (props) => {
  const { title, text, text_b } = props;
  return (
    <div className="about-us-single">
      <h2 className="about-us-single-h2">{title}</h2>
      <p className="about-us-single-p">{text}</p>
      <p className="about-us-single-p-strong">{text_b}</p>
    </div>
  );
};

export default AboutUsSingle;
